import { render, staticRenderFns } from "./GroupPrice.vue?vue&type=template&id=6d7f0b7b&"
import script from "./GroupPrice.vue?vue&type=script&lang=js&"
export * from "./GroupPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports